export const defaultSetReducer = (state, action) => {
  state.filter = action.payload.meta && action.payload.meta.filter ? action.payload.meta.filter : state.filter;
  state.list = action.payload.list;
};
export const defaultUpdateReducer = (state, action) => {
  const index = state.list.findIndex((c) => c.getId() === action.payload.getId());
  if (index !== -1) {
    state.list[index] = action.payload;
  }
};
export const defaultAddReducer = (state, action) => {
  let list = [...state.list];
  list.push(action.payload);
  state.list = list;
};
export const defaultRemoveReducer = (state, action) => {
  state.list = [...state.list].filter((l) => l.getId() !== action.payload.getId());
};
